import BlockProgress from '../api/blockProgress';
import { applicationSave, applicationApiExecute } from './applicationActions';

export const saveBlockProgress = applicationSave(BlockProgress);
export const fetchSqlBlockProgresses = applicationApiExecute(BlockProgress.fetchSqlBlockProgresses);
